export default "__VITE_PUBLIC_ASSET__5df44790__"